
<!-- 
UnvisitCustReasonModal.vue
功能：無法拜訪客戶原因視窗
作者：i9400538 陳博承
完成：2022-01-28
-->
<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">無法拜訪客戶原因</h3>
        </div>
        <div class="padding-left-8">
          <h4>無法拜訪客戶原因為何?(必填)</h4>
          <div class="padding-bottom-5px">名單客戶若因下列情事無法順利約訪，導致無法完成拜訪，才須於下方選項完成回報</div>
          <div class="radio radio-inline">
            <input type="radio" value="1" id="r1" v-model="status" data-vv-as="遷址不明" />
            <label for="r1">遷址不明</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" value="2" id="r2" v-model="status" data-vv-as="查無此址" />
            <label for="r2">查無此址</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" value="3" id="r3" v-model="status" data-vv-as="電話不正確" />
            <label for="r3">電話不正確</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" value="4" id="r4" v-model="status" data-vv-as="客戶拒訪" />
            <label for="r4">客戶拒訪</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" value="5" id="r5" v-model="status" data-vv-as="客戶身故" />
            <label for="r5">客戶身故</label>
          </div>
          <br />
          <div class="radio radio-inline">
            <input type="radio" value="6" id="r6" v-model="status" data-vv-as="客戶旅居海外" />
            <label for="r6">客戶旅居海外</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" value="7" id="r7" v-model="status" data-vv-as="已有其他業務員拜訪" />
            <label for="r7">已有其他業務員拜訪</label>
          </div>
          <div class="radio radio-inline">
            <input type="radio" value="8" id="r8" v-model="status" data-vv-as="無行為能力(如:失智/長照/失去意識)" />
            <label for="r8">無行為能力(如:失智/長照/失去意識)</label>
          </div>
          <br />
          <div class="radio radio-inline">
            <input type="radio" value="9" id="r9" v-model="status" data-vv-as="其他" />
            <label for="r9">其他 :</label>
          </div>
          <input
            type="text"
            id="status_report_text"
            v-model="status_report"
            class="input-txt"
            maxlength="40"
          />
          <br />
          <label class="text-red">※選填「其他」時，請輸入無法拜訪客戶原因。</label>
        </div>
        <br />
        <div class="text-center">
          <button
            type="button"
            class="btn btn-primary"
            @click="doSubmit"
            :disabled="!status || status == '10' || (status == '9' && !status_report.trim())"
          >{{custDataInfo.upd_date ? "更新回報" : "送出"}}</button>
          <button
            v-if="custDataInfo.upd_date"
            type="button"
            class="btn btn-default m-0"
            @click="status='10';warningModalOpen=true"
          >刪除回報</button>
        </div>
      </div>
    </div>
    <!-- 警告視窗 -->
    <warning-modal
      :open="warningModalOpen"
      confirmText="確認"
      message="<h3>請注意!</h3>點選「確認」後將清空您對該筆客戶之「無法拜訪客戶回報」紀錄。若仍須回報無法拜訪紀錄，請重新輸入。"
      @close="panelClose('warningModalOpen')"
      @submit="doSubmit"
    />
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
import WarningModal from "@/desktop/components/WarningModal";
export default {
  name: "UnvisitCustReasonModal",
  mixins: [commonMixin],
  components: { WarningModal },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custDataInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      status: "", //無法拜訪原因
      status_report: "", //備註
      warningModalOpen: false
    };
  },
  watch: {
    open: function() {
      this.init();
    },
    status_report: function() {
      this.status_report = this.cleanSpecialChar(this.status_report, '~()!');
    }
  },
  methods: {
    //初始化
    init() {
      this.status = "";
      this.status_report = "";
      this.warningModalOpen = false;
    },
    //送出
    doSubmit() {
      if (this.warningModalOpen) {
        this.panelClose("warningModalOpen");
      }
      this.$emit(
        "submit",
        this.custDataInfo.policy_no,
        this.custDataInfo.id,
        this.custDataInfo.visit_serno,
        this.status,
        this.status_report
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.padding-bottom-5px {
  padding-bottom: 5px;
}
.padding-left-8 {
  padding-left: 8%;
}

.text-center {
  text-align: center;
}
.min-h {
  padding: 20px 40px;
  min-height: 190px;
  line-height: 1.5;
  position: relative;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
}
.btn-cancel {
  color: #fff;
  border: 1px solid #c66f1c;
  border-radius: 4px;
  box-shadow: none !important;
  border-color: transparent !important;
  background: #c2c4c7 !important;
  display: inline-block;
  padding: 11px 19px;
  margin: 5px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
}
.input-txt {
  border: 1px solid #c2c4c7;
  border-radius: 4px;
}
</style>